// WCAG relative luminance / contrast, for picking readable text on an FI colour.

const channel = (hex, at) => {
  const c = parseInt(hex.slice(at, at + 2), 16) / 255;
  return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

const luminance = (hex) =>
  0.2126 * channel(hex, 1) + 0.7152 * channel(hex, 3) + 0.0722 * channel(hex, 5);

/** WCAG contrast ratio between two `#rrggbb` colours, 1 to 21. */
export const contrast = (a, b) => {
  const [la, lb] = [luminance(a), luminance(b)];
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
};

/** Black or white, whichever reads better on `bg` (the admin portal preview picks the same way). */
export const textOn = (bg) =>
  contrast(bg, "#000000") >= contrast(bg, "#ffffff") ? "#000000" : "#ffffff";
